import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { debounce, autobind } from 'core-decorators'

export default class List extends Component {

  static propTypes = {
    filter: PropTypes.shape({
      onlyWithHostel: PropTypes.bool,
      text: PropTypes.string
    }),
    onChange: PropTypes.func,
  }

  // needded to work with debounce and autobind
  @autobind
  handleTextChange({ target: { name, value, type } }) {
    this.debouncedHandleTextChange({ target: { name, value, type } })
  }

  @debounce(300)
  debouncedHandleTextChange(args) {
    this.handleChange(args)
  }

  @autobind
  handleChange({
    target: {
      name, value, checked, type
    }
  }) {
    if (this.props.onChange) {
      this.props.onChange({
        ...this.props.filter,
        [name]: type === 'checkbox' ? checked : value
      })
    }
  }

  render() {

    return (
      <form
        className="list-filter"
        onChange={this.handleChange}
      >
        <input
          type="text"
          name="text"
          defaultValue={this.props.filter.text}
          placeholder="Filtern nach Name"
        />
        <br />
        <label>
          <input
            type="checkbox"
            name="onlyWithHostel"
            defaultChecked={this.props.filter.onlyWithHostel}
          />
          <span>Nur Angebote mit Jugendherberge</span>
        </label>
      </form>
    )

  }

}



// WEBPACK FOOTER //
// ./src/shared/ListFilter.js